import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  size: 'small' | 'medium' | 'large';
};

export const Title = styled.div<Props>(
  ({theme, size}) => css`
    color: ${theme.colors.contentInversePrimary};
    margin-bottom: ${{
      small: '2px',
      medium: '4px',
      large: '8px',
    }[size]};
    ${theme.elevations.small};
  `
);
